import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/cn";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-start gap-3 py-2", className)}>
      <div className="flex h-9 w-9 items-center justify-center rounded bg-surface-3 text-text-soft">
        <Icon size={18} strokeWidth={1.75} />
      </div>
      <div>
        <p className="text-sm font-medium text-text-strong">{title}</p>
        {description && <p className="mt-1 text-sm text-text-soft">{description}</p>}
      </div>
      {action}
    </div>
  );
}
